// extracted by mini-css-extract-plugin
export var container = "_7k-0";
export var icon = "_7k-1";
export var text = "_7k-2";